import React from 'react';

const TableGridHeader = ({title}) => (
    <div className="tableGridHeader">

        <div className="tableGridHeaderContent">
            <h2 className="tableGridHeaderTitle">{title}</h2>
        </div>
        {title !== '' && (
            <div className="tableGridHeaderUnderline" />

        )}
    </div>
);


export default TableGridHeader;



// WEBPACK FOOTER //
// ./src/Components/TableGridHeader.js